export default "__VITE_ASSET__B7j9YY0t__"